export default {
  PUBNUB_PUBLISH_KEY: process.env.NEXT_PUBLIC_PUBNUB_PUBLISH_KEY || '',
  PUBNUB_SUBSCRIBE_KEY: process.env.NEXT_PUBLIC_PUBNUB_SUBSCRIBE_KEY || '',
}
